import { takeLatest, put, all } from 'redux-saga/effects';
import { getFirebase } from 'react-redux-firebase';
import { GET_ADMIN_USERS, UPDATE_USER_ROLE } from './constants';
import {
  processing,
  getAdminUsersResult,
  updateAdminUserRoleResult,
} from './actions';

function* getAdminUsers({ payload: { brand } }) {
  try {
    yield put(processing(true));
    const usersDoc = yield getFirebase()
      .firestore()
      .collection('users')
      .get();

    const users = usersDoc.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    const filteredUser = users.filter(user => user.brand === brand);

    yield put(getAdminUsersResult(filteredUser));
  } catch (error) {
    yield put(getAdminUsersResult([]));
  } finally {
    yield put(processing(false));
  }
}

function* updateAdminUserRole({ payload }) {
  try {
    yield put(processing(true));

    const { isAdmin, userId } = payload;
    if (Array.isArray(userId)) {
      yield all(
        userId.map(async id => {
          try {
            return await getFirebase()
              .firestore()
              .collection('users')
              .doc(id)
              .set(
                {
                  isClientAdmin: isAdmin,
                },
                {
                  merge: true,
                },
              );
          } catch (error) {
            return null;
          }
        }),
      );
    } else {
      yield getFirebase()
        .firestore()
        .collection('users')
        .doc(userId)
        .set(
          {
            isClientAdmin: isAdmin,
          },
          {
            merge: true,
          },
        );
    }

    yield put(updateAdminUserRoleResult(payload));
  } catch (error) {
    yield put(updateAdminUserRoleResult({ error: true }));
  } finally {
    yield put(processing(false));
  }
}

// Individual exports for testing
export default function* defaultSaga() {
  yield takeLatest(GET_ADMIN_USERS, getAdminUsers);
  yield takeLatest(UPDATE_USER_ROLE, updateAdminUserRole);
}
